/**
 * @file url参数处理方法
 */
export default {
    /**
     * 获取url中的参数
     *
     * @private
     * @param {string} url 需要解析的url
     * @return {Object} args
     */
    getQuery: url => {
        let oUrl = url;
        if (!oUrl) {
            oUrl = window.location.search;
        }
        if (oUrl.indexOf('?') < 0) {
            return {};
        }
        const queryParam = oUrl.substring(oUrl.indexOf('?') + 1, oUrl.length).split('&');
        const args = {};
        queryParam.map(item => {
            args[item.substring(0, item.indexOf('='))] = decodeURIComponent(item.substring(item.indexOf('=') + 1, item.length));
            return false;
        });
        return args;
    },
    replaceUrlParam: (link, paramName, paramVal) => {
        let url = link;
        let paramValue = paramVal;
        const pattern = new RegExp(`\\b(${paramName}=).*?(&|#|$)`);
        if (paramValue === null) {
            paramValue = '';
        }
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, `$1${paramValue}$2`);
        }
        url = url.replace(/[?#]$/, '');
        return `${url + (url.indexOf('?') > 0 ? '&' : '?') + paramName}=${paramValue}`;
    }
};
